module.exports = __webpack_public_path__ + "img/1.6e105fab.jpg";